import * as React from "react";
import { Text } from "react-native";

interface SubtitleProps {
  text: string;
}

export default function Subtitle(props: SubtitleProps) {
  return (
    <Text className="text-darkergray text-center text-sm">{props.text}</Text>
  );
}
